module.exports = __webpack_public_path__ + "static/media/invalid.e0d006dd.wav";